<template>
	<div class="layout-topbar">
		<button class="p-link layout-menu-button" @click="onMenuToggle">
			<span class="pi pi-bars"></span>
		</button>
		<div class="layout-topbar-icons">
			<label>{{ usuarioLogado }}</label>				
			<button class="p-link" @click="logout" title="Sair">
				<span class="layout-topbar-item-text">Sair</span>
				<span class="layout-topbar-icon pi pi-power-off"></span>
			</button>
		</div>
		<Menu id="overlay_menu" ref="menu" :model="itens" :popup="true" appendTo="body" style="width: 220px"/>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
	props: ['usuarioLogado'],
	data() {
		return {
			itens: [],
		}
	},
    methods: {
		...mapActions('sessao', ['limparSessao']),
		...mapGetters('sessao', ['getPermissoes']), 
        onMenuToggle(event) {
            this.$emit('menu-toggle', event);
		},
		logout() {
			this.limparSessao();
			this.$router.push('/login');
		},
		meusDados() {
			this.$router.push('/conta/meus-dados');
		},
		toggle(event) {			
            this.$refs.menu.toggle(event);
		},
		validarPermissoes() {
			let permissoes = this.getPermissoes();
			let itensMenu = [
				{label: 'Usuários', icon: 'pi pi-user', to: '/sistema/usuarios', permissao: 2}, 
				{label: 'Perfis e Permissões', icon: 'pi pi-exclamation-circle', to: '/sistema/perfis-permissoes', permissao: 7},
				{label: 'Logs de Operações', icon: 'pi pi-align-center', to: '/sistema/logs-operacoes', permissao: 12}
			];
			let menuFiltrado = [];
			itensMenu.forEach(menu => {
				if(permissoes.includes(menu.permissao)) {
					menuFiltrado.push(menu);
				}
			});
			this.itens = menuFiltrado;
		}
	},
	created() {
		this.validarPermissoes();
	}
}
</script>